import React, { useState } from 'react';
import './ContactForm.css';
import contactImage from '../../../assets/Gallery/contactImage.png';

function ContactForm() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        course: '',
        age: '',
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const message = `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\nCourse: ${formData.course}\nAge: ${formData.age}`;
        const whatsappURL = `https://wa.me/918016096294?text=${encodeURIComponent(message)}`;
        window.open(whatsappURL, '_blank');
    };

    return (
        <div className='contactform-outer'>
            <div className="contactform-inner">
                <div className="contact-left">
                    <img src={contactImage} alt="" loading='lazy' />
                </div>
                <div className="contact-right">
                    <form onSubmit={handleSubmit}>
                        <div className="contact-div">
                            <label htmlFor="name">Name</label>
                            <input type="text" id='name' value={formData.name} onChange={handleChange} required />
                        </div>
                        <div className="contact-div">
                            <label htmlFor="email">Email Address</label>
                            <input type="email" id='email' value={formData.email} onChange={handleChange} required />
                        </div>
                        <div className="contact-div">
                            <label htmlFor="phone">Phone Number</label>
                            <input type="tel" id='phone' value={formData.phone} onChange={handleChange} required />
                        </div>
                        <div className="contact-div">
                            <label htmlFor="course">Course You Are Interested IN?</label>
                            <input type="text" id='course' value={formData.course} onChange={handleChange} required />
                        </div>
                        <div className="contact-div">
                            <label htmlFor="age">Age</label>
                            <input type="number" id='age' value={formData.age} onChange={handleChange} required />
                        </div>
                        <div className="submit-button">
                            <button type="submit" className='cta-text'>Submit</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default ContactForm;
